<template>
	<footer class="d-none">
		<div class="container">
			<div class="footer-content">
				<p>
					© 2021 Duckist. All rights reserved.
				</p>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
	}
</script>

<style scoped lang="scss">
	@import "../assets/scss/footer.scss";
</style>
